import { Box, Tooltip } from '@chakra-ui/react';
import { IconCircleInfo } from 'central-icons/IconCircleInfo';
import type { ReactNode } from 'react';

import styles from './TreeTooltip.module.css';

const PAGE_CONTAINER_CLASS_NAME = 'revelio-page-container-class-name';

export const TreeTooltip = ({
  label,
  mt = '0px',
}: {
  label: ReactNode;
  mt?: string;
}) => {
  return (
    <Tooltip
      label={label}
      placement="top"
      hasArrow
      bg="navyBlue.500"
      padding="12px"
      fontSize="12px"
      maxWidth="330px"
      borderRadius="4px"
      modifiers={[
        {
          name: 'preventOverflow',
          options: {
            boundary: document.querySelector(`.${PAGE_CONTAINER_CLASS_NAME}`),
            padding: { left: 10 },
          },
        },
      ]}
    >
      <Box as="span" mt={mt} className={styles.infoIcon}>
        <IconCircleInfo size={14} color="currentColor" />
      </Box>
    </Tooltip>
  );
};
